<template>
  <div class="container">
    <h5
      class="value"
      :style="color ? { color } : ''"
    >
      {{ value }}
    </h5>
    <span class="p4 label">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'RecruitingPerformanceCell',
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  border-left: 1px solid @stroke-default;
  padding: 5px 15px;
  height: 100%;
}

.value {
  color: @text-brand;
}

.datapeople-app .p4.label {
  font-weight: 300;
  white-space: nowrap;
}
</style>
